import React__default from 'react';
import { TableActionsCore } from '../shared/components/TableActions.mjs';
export { TABLE_ACTIONS_HEADER } from '../shared/components/TableActions.mjs';
import { Button } from './Button.mjs';

const TableActions = (props)=>{
    return /*#__PURE__*/ React__default.createElement(TableActionsCore, {
        ...props,
        ButtonComponent: Button
    });
};

export { TableActions };
//# sourceMappingURL=TableActions.mjs.map
